import { lazy } from "react";
import { RouteType, type } from "./components/Router";
import AuthLayout from "./layouts/auth/auth.layout";
import AppLayout from "./layouts/app/app.layout";
import PublicLayout from "./layouts/public/public.layout";

const GenericError = lazy(() => import("./components/ErrorBoundary"));
const Login = lazy(() => import("./pages/auth/login"));
const PasswordForgotPage = lazy(() => import("./pages/auth/forgotPassword"));
const PasswordResetPage = lazy(() => import("./pages/auth/resetPassword"));
const Forbidden = lazy(() => import("./pages/auth/forbidden"));
const Home = lazy(() => import("./pages/home"));
const Dossiers = lazy(() => import("./pages/dossiers"));
const DossierDetail = lazy(
  () => import("./pages/dossiers/pages/dossierDetail"),
);
const Users = lazy(() => import("./pages/users"));
const Setup = lazy(() => import("./pages/setup"));
const PaymentResult = lazy(() => import("./pages/payment-result"));

export const routes: RouteType[] = [
  {
    id: "genericError",
    path: "/generic-error",
    titleLocalizationKey: "genericError.title",
    component: GenericError,
    type: type.PUBLIC,
  },
  {
    id: "login",
    path: "/login",
    titleLocalizationKey: "pages.login.title",
    component: Login,
    layout: AuthLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "passwordForgot",
    path: "/forgot-password",
    titleLocalizationKey: "pages.login.title",
    component: PasswordForgotPage,
    layout: AuthLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "passwordReset",
    path: "/recovery-password",
    titleLocalizationKey: "pages.reset_password.title",
    component: PasswordResetPage,
    layout: AuthLayout,
  },
  {
    id: "forbidden",
    path: "/forbidden",
    titleLocalizationKey: "pages.forbidden.title",
    component: Forbidden,
    type: type.PUBLIC,
  },
  {
    id: "home",
    path: "/",
    titleLocalizationKey: "pages.home.title",
    component: Home,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
  },
  {
    id: "dossiers",
    path: "/dossiers",
    titleLocalizationKey: "pages.dossiers.title",
    component: Dossiers,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
  },
  {
    id: "dossierDetail",
    titleLocalizationKey: "pages.dossiers.title",
    path: "/dossiers/:dossierId",
    component: DossierDetail,
    showInMenu: false,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
  },
  {
    id: "users",
    path: "/users",
    titleLocalizationKey: "pages.users.title",
    component: Users,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
  },
  {
    id: "setup",
    path: "/setup",
    titleLocalizationKey: "pages.setup.title",
    component: Setup,
    layout: AppLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
  },
  {
    id: "paymentResult",
    path: "/payment-result",
    titleLocalizationKey: "pages.payment_result.title",
    component: PaymentResult,
    layout: PublicLayout,
    type: type.PUBLIC,
  },
];
